<template>
<div class="page-container md-layout-column">
      <nav class="navbar navbar-light bg-light justify-content-between nav-shadow">
        <vue-confirm-dialog></vue-confirm-dialog>
        <md-button class="md-icon-button" @click="showNavigation = true">
        <md-icon>menu</md-icon>
      </md-button>
      <a class="navbar-brand" style="width:50%;"><img src="/img/icons/logo.png" class= "nav-header-img" style="float:left"></a>
    <i class="fa  fa-power-off navbar-toggler" style="border:none;cursor:pointer;" @click.stop="logout()"></i>

</nav>


<md-drawer :md-active.sync="showNavigation" md-swipeable style="min-height: 100vh;">
      <md-toolbar class="md-transparent" md-elevation="0">
        <span class="md-title">Workman's Dashboard</span>
      </md-toolbar>

      <md-list>
        <md-list-item to="/dashboard" md-expand>
          <md-icon>dashboard</md-icon>
          <span class="md-list-item-text">Dashboard</span>

          <md-list slot="md-expand"  v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.foreman.flag|| roles_list.salesman.flag">
            <md-list-item class="md-inset" to="/foreman"  v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.foreman.flag|| roles_list.salesman.flag">Foreman Dashboard</md-list-item>
            <md-list-item class="md-inset" to="/project-manager" v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.project_manager.flag|| roles_list.salesman.flag">Project Manager Dashboard</md-list-item>
            <md-list-item class="md-inset" to="/estimator" v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.estimator.flag|| roles_list.salesman.flag">Estimator Dashboard</md-list-item>
             <md-list-item class="md-inset" to="/accounting"  v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.accounting.flag|| roles_list.salesman.flag">Accounting Dashboard</md-list-item>
          </md-list>
        </md-list-item>
        <md-list-item to="/assignments" v-if="roles_list.foreman.flag || roles_list.time_entry.flag">
          <md-icon>assignment</md-icon>
          <span class="md-list-item-text">Assignments</span>
        </md-list-item>
        <md-list-item to="/timesheets" md-expand>
          <md-icon>access_time</md-icon>
          <span class="md-list-item-text">Timekeeping</span>

          <md-list slot="md-expand">
            <md-list-item class="md-inset" to="/timesheets">Timesheets</md-list-item>
          </md-list>
        </md-list-item>
        <md-list-item to="/lineups" v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.accounting.flag || roles_list.project_manager.flag || roles_list.estimator.flag || roles_list.foreman.flag || roles_list.salesman.flag">
          <md-icon>view_list</md-icon>
          <span class="md-list-item-text">Lineup</span>
        </md-list-item>
        <md-list-item
          to="/ai-chat"
          v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.accounting.flag || roles_list.project_manager.flag || roles_list.estimator.flag"
        >
          <md-icon>smart_toy</md-icon>
          <span class="md-list-item-text">AI Assistant</span>
        </md-list-item>
        <md-list-item to="/jobs" md-expand v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.salesman.flag">
          <md-icon>work</md-icon>
          <span class="md-list-item-text">Jobs</span>

          <md-list slot="md-expand"  v-if="roles_list.admin.flag || roles_list.executive.flag || roles_list.foreman.flag|| roles_list.salesman.flag">
        <md-list-item to="/jobs" class="md-inset" v-if="roles_list.salesman.flag||roles_list.project_manager.flag||roles_list.estimator.flag ||  roles_list.executive.flag||roles_list.admin.flag|| roles_list.accounting.flag">

          <span class="md-list-item-text">View Jobs</span>
        </md-list-item>
        <md-list-item to="/job" class="md-inset" v-if="roles_list.salesman.flag||roles_list.project_manager.flag||roles_list.estimator.flag ||  roles_list.executive.flag||roles_list.admin.flag|| roles_list.accounting.flag">

          <span class="md-list-item-text">Add Job</span>
        </md-list-item>
          </md-list>
        </md-list-item>
        <md-list-item :to="'/my-credentials/'+ userData.id"  v-if="roles_list.foreman.flag|| roles_list.time_entry.flag">
          <md-icon>settings_applications</md-icon>
          <span class="md-list-item-text">Credentials</span>
        </md-list-item>
        <md-list-item :to="'/my-skills/'+ userData.id"  v-if="roles_list.foreman.flag|| roles_list.time_entry.flag || roles_list.admin.flag || roles_list.executive.flag || roles_list.accounting.flag || roles_list.project_manager.flag || roles_list.estimator.flag || roles_list.salesman.flag">
          <md-icon>star</md-icon>
          <span class="md-list-item-text">Skills</span>
        </md-list-item>

      </md-list>
    </md-drawer>
</div>

</template>

<script>
import CommonConstants from '@/constants/constants.js'
import Vue from 'vue';
export default {
name: 'Header',
data() {
      return {
        constants: CommonConstants,
        header: {},
        roles_list: JSON.parse(localStorage.getItem('permissions')),
        userData: {},
        route: '',
        showNavigation:false

      }
    },
    created: function () {
      let self = this;
      self.header = {
        'Content-type': "application/json",
        'token': localStorage.getItem('token')
      }
      self.userData = JSON.parse(localStorage.getItem('userData'))
    },
    mounted: function () {
      let self = this
      self.route = self.$route.path
    },
    methods: {
      logout: function () {
        let self = this
        this.$vueConfirm.confirm(
        {
          message: `Are you sure? You want to logout`,
          button: {
            no: 'No',
            yes: 'Yes'
          }
          },
            function(confirm) {
              if (confirm == true) {
                self.$vueConfirm.close()
                axios.get(self.constants.api_url + 'logout', {headers: self.header})
                .then(function (response) {
                  if (response.data.flag) {
                    self.$session.destroy()
                     Vue.$toast.success('You have been logged out successfully', {
                      position: 'top'
                      });
                    self.$session.start()
                    self.$session.set('tempUrl', self.$route.fullPath)
                    localStorage.removeItem("token")
                    localStorage.removeItem("userData")
                    self.$router.push('/login')
                    self.$router.go()
                  } else {
                    self.$session.destroy()
                    localStorage.removeItem("token")
                    Vue.$toast.error(response.data.message, {
                      position: 'top'
                      });
                    self.$router.go()
                  }
                })
                .catch(function (error) {
                  Vue.$toast.success(error, {
                      position: 'top'
                      });
                })
              }
            }
          )


      }
    }
}
</script>

<style>

</style>
